import React, { useEffect } from "react";
import styles from "./PrivacyPolicy.module.css";

import { BsDot } from "react-icons/bs";
import { FaFileDownload } from "react-icons/fa";

const rightsRequestFormUrl = "/docs/el/Εντυπο_Ασκησης_Δικαιωματων.docx";
const rightsRequestFormFileName = "Εντυπο_Ασκησης_Δικαιωματων.docx";

const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = "Privacy Policy - The Reords Hub S.A.";
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className={styles.mainContainer}>
      <strong>
        ΠΟΛΙΤΙΚΗ ΑΠΟΡΡΗΤΟΥ ΤΗΣ
        <br />
        THE RECORDS HUB S.A.
      </strong>
      <p>
        Αποτελεί δέσμευση της The Records Hub S.A. αφενός η τήρηση του απορρήτου
        και της ασφάλειας των Δεδομένων Προσωπικού Χαρακτήρα (ΔΠΧ), τα οποία
        συλλέγονται κατά την ενάσκηση των σκοπών του και της εν γένει
        δραστηριότητάς του και αφετέρου η συμμόρφωσή του με τους εφαρμοστέους
        νόμους και κανονισμούς σχετικά με την επεξεργασία ΔΠΧ.
        <br />Η πολιτική προστασίας δεδομένων της The Records Hub S.A. βασίζεται
        στις ακόλουθες αρχές:
        <ul>
          <li>
            Η επεξεργασία προσωπικών δεδομένων λαμβάνει χώρα με ένα νόμιμο,
            δίκαιο και διαφανή τρόπο.
          </li>
          <li>
            Η επεξεργασία προσωπικών δεδομένων θα πραγματοποιείται μόνο για
            καθορισμένους, σαφείς και νόμιμους σκοπούς και περαιτέρω δεν θα
            τυγχάνουν επεξεργασίας με τρόπο που είναι ασυμβίβαστος με τους
            σκοπούς αυτούς.
          </li>
          <li>
            Η επεξεργασία προσωπικών δεδομένων θα είναι επαρκής, σχετική και
            περιορισμένη σε αυτό το οποίο είναι απαραίτητο σε σχέση με τον σκοπό
            της επεξεργασίας.
          </li>
          <li>
            Τα προσωπικά δεδομένα θα πρέπει να είναι ακριβή και όπου απαραίτητο,
            επικαιροποιημένα.
          </li>
          <li>
            Προσωπικά δεδομένα θα πρέπει να τηρούνται σε μία μορφή που επιτρέπει
            ταυτοποίηση του υποκειμένου των δεδομένων για όχι μεγαλύτερο χρονικό
            διάστημα από αυτό που είναι απαραίτητο για το σκοπό της
            επεξεργασίας.
          </li>
          <li>
            Όλα τα προσωπικά δεδομένα θα μένουν εμπιστευτικά και αποθηκευμένα με
            τρόπο που θα διασφαλίζει την προστασία τους.
          </li>
          <li>
            Προσωπικά δεδομένα δε θα διαβιβάζονται σε τρίτους εκτός εάν είναι
            απαραίτητο για το σκοπό της επεξεργασίας τους.
          </li>
          <li>
            Υποκείμενα δεδομένων θα έχουν δικαίωμα να απαιτήσουν πρόσβαση,
            διόρθωση ή διαγραφή προσωπικών δεδομένων, ή περιορισμό επεξεργασίας,
            ή να αντιταχθούν στην επεξεργασία όπως επίσης και το δικαίωμα της
            φορητότητας δεδομένων.
          </li>
        </ul>
        Όταν συμπληρώνετε προσωπικά στοιχεία σας όπως το ονοματεπώνυμό σας, τη
        διεύθυνση ηλεκτρονικού ταχυδρομείου σας, μέσω των εντύπων που βρίσκονται
        αναρτημένα στην ιστοσελίδα μας https://therecordshub.com/ συμφωνείτε
        στην επεξεργασία των προσωπικών σας δεδομένων για το σκοπό, που
        αναφέρεται στη φόρμα που συμπληρώσατε.
        <br />
        Σε καμία περίπτωση τα προσωπικά σας στοιχεία δεν θα μεταφερθούν ή θα
        χρησιμοποιηθούν από οποιονδήποτε τρίτο.
        <br />
        Η The Records Hub S.A. έχει υιοθετήσει πολιτικές και έχει εφαρμόσει
        τεχνικά και οργανωτικά μέτρα για να εξασφαλίσει ότι τα προσωπικά
        δεδομένα που συλλέγει προστατεύονται σύμφωνα με τους ισχύοντες νόμους
        περί ιδιωτικότητας και προστασίας δεδομένων.
        <br />
        Αυτά τα μέτρα ασφαλείας έχουν σχεδιαστεί για να αποτρέπουν την παράνομη
        πρόσβαση, την ακατάλληλη χρήση ή αποκάλυψη των δεδομένων, τη μη
        εξουσιοδοτημένη τροποποίηση και την παράνομη καταστροφή ή τυχαία απώλεια
        των προσωπικών σας δεδομένων.
        <br />
        Τα προσωπικά σας δεδομένα τηρούνται από την The Records Hub S.A. μόνο
        για όσο διάστημα είναι απαραίτητο για την πραγμάτωση των σκοπών
        επεξεργασίας σύμφωνα με τους ισχύοντες νόμους.
        <br />
        Δεν συλλέγουμε περισσότερα προσωπικά δεδομένα από όσα χρειαζόμαστε για
        την εκπλήρωση των σκοπών που αναφέρονται στην παρούσα πολιτική απορρήτου
        και δεν θα τα διατηρήσουμε για περισσότερο από το χρονικό εκείνο
        διάστημα που κρίνεται απαραίτητο.
        <br />
        Τα δικαιώματα σας αναφορικά με την προστασία των προσωπικών σας
        δεδομένων.
        <br />
        Τα δικαιώματά σας για την προστασία των προσωπικών σας δεδομένων, όπως
        αυτά ισχύουν υπό τις προϋποθέσεις που ορίζονται στο Γενικό Κανονισμό
        Προσωπικών Δεδομένων (Ε.Ε. 679/2016) και στην εφαρμοστέα εθνική
        νομοθεσία, είναι τα ακόλουθα:
        <ul>
          <li>
            Δικαίωμα πρόσβασης στα προσωπικά σας δεδομένα που τηρεί, διαθέτει
            και επεξεργάζεται η The Records Hub S.A..
          </li>
          <li>
            Δικαίωμα διόρθωσης ανακριβών ή ανεπίκαιρων δεδομένων που σας αφορούν
            ή συμπλήρωσης ελλιπών δεδομένων σας.
          </li>
          <li>
            Δικαίωμα διαγραφής δεδομένων σας από τα αρχεία της The Records Hub
            S.A. εφόσον η επεξεργασία τους δεν είναι απαραίτητη για την επιδίωξη
            των σκοπών για τους οποίους έχουν συλλεγεί.
          </li>
          <li>
            Δικαίωμα περιορισμού της χρήσης δεδομένων σας σε περίπτωση που
            αμφισβητείτε την ακρίβειά τους.
          </li>
          <li>
            Δικαίωμα λήψης των δεδομένων που έχετε ο ίδιος παράσχει σε δομημένο,
            κοινώς χρησιμοποιούμενο μορφότυπο.
          </li>
        </ul>
        Η άσκηση των προαναφερομένων δικαιωμάτων προϋποθέτει την υποβολή, χωρίς
        κόστος,{" "}
        <a
          className={styles.inlineLink}
          href={rightsRequestFormUrl}
          download={rightsRequestFormFileName}
        >
          έγγραφης αίτησης
        </a>{" "}
        στην The Records Hub S.A..
        <br />
        Για οποιοδήποτε θέμα, συμπεριλαμβανομένης της διάθεσης της Πολιτικής
        Ασφαλείας, μπορείτε να απευθυνθείτε στην The Records Hub S.A., διεύθυνση
        Αιγέα 64, Θέση Κόντι, Κορωπί Αττικής Τ.Κ. 19441, Ελλάδα, τηλέφωνο: +30
        2113110870, email dpo@therecordshub.com σε κάθε δε περίπτωση έχετε
        δικαίωμα να απευθυνθείτε στην Αρχή Προστασίας Δεδομένων Προσωπικού
        Χαρακτήρα είτε γραπτώς (Κηφισιάς 1-3, Τ.Κ. 115-23) είτε ηλεκτρονικά
        (www.dpa.gr).
        <br />
        Σε περίπτωση άσκησης ενός εκ των προαναφερόμενων δικαιωμάτων, η The
        Records Hub S.A. θα λάβει κάθε δυνατό μέτρο για την ικανοποίησή του
        εντός τριάντα (30) ημερολογιακών ημερών από τη λήψη της σχετικής
        αίτησης, ενημερώνοντας γραπτώς για την ικανοποίησή του, ή τους λόγους
        που εμποδίζουν την άσκηση.
      </p>
      <div className={styles.rightsFormCallout}>
        <div className={styles.rightsFormContent}>
          <strong>Άσκηση δικαιωμάτων υποκειμένου</strong>
          <span>
            Κατεβάστε το έντυπο, συμπληρώστε το και αποστείλετέ το στο
            dpo@therecordshub.com.
          </span>
        </div>
        <a
          className={styles.downloadLink}
          href={rightsRequestFormUrl}
          download={rightsRequestFormFileName}
        >
          <FaFileDownload aria-hidden="true" />
          Κατεβάστε το έντυπο (.docx)
        </a>
      </div>
      <strong>Πολιτική Cookies</strong>
      <p>1. Τι είναι τα cookies;</p>
      <p>
        Τα «cookies» είναι μικρά κομμάτια αρχείων σε μορφή κειμένου, τα οποία
        αποθηκεύονται στον περιηγητή (browser) του Χρήστη όταν επισκέπτεται έναν
        ιστότοπο. Οι πληροφορίες οι οποίες αποθηκεύονται στον υπολογιστή του
        Χρήστη μπορεί να περιέχουν στοιχεία όπως ποιες είναι οι σελίδες που
        επισκέφτηκε ο Χρήστης, την ημερομηνία και την ώρα της επίσκεψης καθώς
        και κάποιον τυχαίο και μοναδικό αριθμό αναγνώρισης του Χρήστη. Σε καμία
        περίπτωση τα cookies δεν περιέχουν προσωπικές πληροφορίες ή πληροφορίες,
        οι οποίες θα επιτρέψουν σε οποιονδήποτε να επικοινωνήσει με τον
        επισκέπτη του δικτυακού τόπου, μέσω τηλεφώνου, e-mail, κ.λπ. Επιπλέον,
        με την χρήση των cookies δεν υπάρχει πρόσβαση στα έγγραφα ή αρχεία του
        υπολογιστή σας.
        <br />
        Με την χρήση αυτή, το Site είναι σε θέση να αποθηκεύσει χρήσιμες
        πληροφορίες για την περιήγηση του Χρήστη στο Site, καθώς και να διαβάσει
        τις πληροφορίες αυτές ώστε να προσφέρει στον Χρήστη μια ενοποιημένη
        εμπειρία περιήγησης.
        <br />
        Επιπλέον, τα cookies μας βοηθούν να βλέπουμε την απόδοση και την
        επισκεψιμότητα της ιστοσελίδας μας, βελτιώνοντας την παρουσίαση και το
        περιεχόμενό της, σύμφωνα με τις προτιμήσεις των επισκεπτών μας.
        <br />
        2. Ποια cookies χρησιμοποιούμε στον Δικτυακό μας Τόπο;
        <br />
        Χρησιμοποιούμε cookies στους Δικτυακούς μας Τόπους για τη διαχείριση των
        περιόδων σύνδεσης, για την παροχή εξατομικευμένων ιστοσελίδων και για
        την προσαρμογή διαφημιστικού και άλλου περιεχομένου ώστε να
        αντικατοπτρίζει τις ιδιαίτερες ανάγκες και τα ενδιαφέροντά σας. Επίσης
        τα cookies μπορούν να χρησιμοποιηθούν για να συντάξουμε ανώνυμες,
        αθροιστικές στατιστικές που μας επιτρέπουν να αντιληφθούμε πώς το κοινό
        χρησιμοποιεί τους Δικτυακούς μας Τόπους και βοηθούν να βελτιώσουμε την
        δομή και το περιεχόμενό του. Δεν μπορούμε να εξακριβώσουμε την προσωπική
        σας ταυτότητα από τις πληροφορίες αυτές. Μπορείτε να τροποποιήσετε τις
        ρυθμίσεις του προγράμματος περιήγησης για να απορρίψετε ορισμένα ή και
        όλα τα cookies, εκτός των απολύτως απαραίτητων. Θα πρέπει να γνωρίζετε
        ότι κάποιες λειτουργίες είναι διαθέσιμες μόνο μέσω της χρήσης cookies
        και εάν επιλέξετε την απόρριψη των cookies, αυτές οι λειτουργίες
        ενδέχεται να μην είναι διαθέσιμες. Γενικά υπάρχουν οι παρακάτω
        κατηγορίες cookies που χρησιμοποιούνται στους Δικτυακούς μας Τόπους.
        <br />
        <BsDot /> Αναγκαία cookies
        <br />
        Τα αναγκαία, άλλως, απολύτως απαραίτητα cookies, είναι ουσιαστικής
        σημασίας για την ορθή λειτουργία των Δικτυακών μας Τόπων, σας επιτρέπουν
        να κάνετε περιήγηση και να χρησιμοποιήσετε τις λειτουργίες τους, όπως
        πρόσβαση σε ασφαλείς περιοχές ή χρήση του καλαθιού αγοράς. Αυτά τα
        cookies δεν αναγνωρίζουν την ατομική σας ταυτότητα. Χωρίς αυτά τα
        cookies, δεν μπορούμε να προσφέρουμε αποτελεσματική λειτουργία των
        Δικτυακών μας Τόπων.
        <br />
        <BsDot /> Cookies Λειτουργικότητας (Προτιμήσεων)
        <br />
        Αυτά τα cookies επιτρέπουν στους Δικτυακούς Τόπους να θυμούνται τις
        επιλογές του χρήστη όπως το όνομα χρήστη, τη γλώσσα ή τη περιοχή, ώστε
        να παρέχουν βελτιωμένες και προσωποποιημένες λειτουργίες. Μπορούν επίσης
        να χρησιμοποιηθούν για την παροχή υπηρεσιών που έχουν ζητηθεί από το
        χρήστη, όπως προβολή βίντεο ή χρήση μέσων κοινωνικής δικτύωσης. Οι
        πληροφορίες που συλλέγουν αυτά τα cookies μπορεί να γίνουν ανώνυμες και
        δεν είναι δυνατόν να παρακολουθήσουν την δραστηριότητα της περιήγησής σε
        άλλους ιστότοπους. Αν δεν δεχθείτε αυτά τα cookies, μπορεί να επηρεαστεί
        η απόδοση και λειτουργικότητα των Δικτυακών Τόπων και να περιοριστεί η
        πρόσβασή σας σε περιεχόμενο του.
        <br />
        <BsDot /> Cookies επιδόσεων (Στατιστικά)
        <br />
        Αυτά τα cookies συλλέγουν πληροφορίες σχετικά με τον τρόπο που οι
        επισκέπτες χρησιμοποιούν τους Δικτυακούς μας Τόπους, για παράδειγμα,
        ποιες σελίδες επισκέπτονται συχνότερα και αν λαμβάνουν μηνύματα
        σφαλμάτων από ιστοσελίδες. Αυτά τα cookies συλλέγουν συγκεντρωτικές,
        ανώνυμες πληροφορίες που δεν ταυτοποιούν κάποιον επισκέπτη.
        Χρησιμοποιούνται αποκλειστικά για τη βελτίωση των επιδόσεων μίας
        ιστοσελίδας.
        <br />
        <BsDot /> Cookies εμπορικής προώθησης
        <br />
        Αυτά τα cookies χρησιμοποιούνται για την παροχή περιεχομένου, που
        ταιριάζει περισσότερο σε εσάς και τα ενδιαφέροντά σας. Μπορεί να
        χρησιμοποιηθούν για την αποστολή στοχευμένης διαφήμισης/προσφορών, τον
        περιορισμό προβολών διαφήμισης ή την μέτρηση αποτελεσματικότητας μιας
        διαφημιστικής καμπάνιας. Μπορεί να χρησιμοποιηθούν αυτά τα cookies για
        να θυμόμαστε τους ιστότοπους που έχετε επισκεφθεί ώστε να καθορίσουμε
        ποια ηλεκτρονικά κανάλια μάρκετινγκ είναι πιο αποτελεσματικά και μας
        επιτρέπουν να επιβραβεύσουμε εξωτερικές ιστοσελίδες και συνεργάτες που
        σας προώθησαν σε εμάς.
        <br />
        <BsDot /> Αταξινόμητα cookies
        <br />
        Τα αταξινόμητα cookies είναι τα cookies που είναι σε στάδιο ταξινόμησης,
        από κοινού με τους παρόχους μεμονωμένων cookies.
        <br />
      </p>
      <p>
        3. Πώς να ελέγξετε τα cookies;
        <br />
        Είναι στη διακριτική σας ευχέρεια να ανακαλείτε, όποτε το θελήσετε, τη
        συγκατάθεση σας ή να εναντιωθείτε στη χρήση των cookies στον υπολογιστή
        ή τη συσκευή σας, να ελέγξετε ή/και να διαγράψετε τα cookies.
        <br />
        4. Ποιά είναι τα δικαιώματα σας;
        <br />
        Έχετε τα δικαιώματα:
        <ul>
          <li>Πρόσβασης στα δεδομένα σας</li>
          <li>Διόρθωσης ή Διαγραφής των δεδομένων σας</li>
          <li>Φορητότητας των δεδομένων σας</li>
          <li>Περιορισμού της επεξεργασίας των δεδομένων σας</li>
          <li>Εναντίωσης στην επεξεργασία των δεδομένων σας</li>
          <li>
            Άρσης της συγκατάθεσης σας για τη χρήση κάποιων ή του συνόλου των
            cookies και κατ’ επέκταση για την επεξεργασία των δεδομένων σας.
          </li>
        </ul>
      </p>
      <p>
        Για να ασκήσετε τα ανωτέρω δικαιώματά σας μπορείτε να υποβάλετε το
        αίτημά σας στα κεντρικά γραφεία της THE RECORDS HUB S.A. Αιγέα 64, Θέση
        Κόντι, Κορωπί Αττικής Τ.Κ. 19441, Ελλάδα, τηλεφωνικά στο: +30
        2113110870, ή στην ηλεκτρονική διεύθυνση dpo@therecordshub.com. καθώς
        και να υποβάλετε, σε περίπτωση που θεωρήσετε ότι η επεξεργασία των
        προσωπικών σας δεδομένων παραβιάζει τον ισχύον δίκαιο για την προστασία
        των προσωπικών δεδομένων, καταγγελία στην Αρχή Προστασίας Προσωπικών
        Δεδομένων (ταχυδρομική δ/νση Κηφισίας 1-3, Τ.Κ. 115 23, Αθήνα, τηλ. 210.
        6475600, δ/νση ηλεκτρονικού ταχυδρομείου contact@dpa.gr).
      </p>
      <p>
        Εάν επιθυμείτε να επικοινωνήσετε για κάθε ζήτημα σχετικό με την
        επεξεργασία των προσωπικών σας δεδομένων και την άσκηση των δικαιωμάτων
        σας, μπορείτε να απευθυνθείτε στον Υπεύθυνο Προστασίας δεδομένων (DPO)
        της THE RECORDS S.A., στη διεύθυνση Αιγέα 64, Θέση Κόντι, Κορωπί Αττικής
        Τ.Κ. 19441, Ελλάδα, ή στην δ/νση ηλεκτρονικού ταχυδρομείου (e-mail)
        dpo@therecordshub.com .
      </p>
      <p>
        5. Πού μπορείτε να βρείτε περισσότερες πληροφορίες για την προστασία των
        προσωπικών δεδομένων που συλλέγουν τα cookies;
        <br />
        Πληροφορίες για την προστασία των προσωπικών δεδομένων σας, αλλά και για
        τα δικαιώματα σας θα βρείτε στην Πολιτική Απορρήτου
      </p>
      <p>
        6. Πού μπορείτε να βρείτε περισσότερες πληροφορίες για τη γενική χρήση
        cookies;
        <br />
        Περισσότερες πληροφορίες σχετικά με τη γενική χρήση των cookies, αλλά
        και των μεθόδων αποκλεισμού ή περιορισμού τους, θα βρείτε στις
        ιστοσελίδες cookiepedia.co.uk/all-about-cookies και
        www.allaboutcookies.org/.
        <br />
        Σε περίπτωση που επιθυμείτε να ενεργοποιήσετε ή να απενεργοποιήσετε τη
        χρήση των cookies από τις ρυθμίσεις του πλοηγητή (browser), μπορείτε να
        επισκεφθείτε τις παρακάτω ιστοσελίδες και να ενημερωθείτε για τις
        απαραίτητες ενέργειες που χρειάζεται να πραγματοποιήσετε.
        <br />
        <BsDot /> Internet Explorer //support.microsoft.com/kb/278835
        <br />
        <BsDot /> Firefox
        //support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored
        <br />
        <BsDot /> Chrome //support.google.com/accounts/answer/61416?hl=en
        <br />
        <BsDot /> Safari //support.apple.com/kb/PH5042
        <br />
        <BsDot /> Safari for iPad and iPhone //support.apple.com/kb/HT1677
        <br />
      </p>
      <p>
        7. Αλλαγές στην Πολιτική cookies.
        <br />Η παρούσα Πολιτική Cookies ενδέχεται να τροποποιηθεί οποιαδήποτε
        στιγμή. Για το λόγο αυτό κρίνουμε σκόπιμο να ανατρέχετε τακτικά στην
        παρούσα Πολιτική. Η παρούσα τέθηκε σε ισχύ στις 15 Φεβρουαρίου 2021. Σε
        περίπτωση τροποποίησής της θα αναφέρεται η ημερομηνία που αυτή έλαβε
        χώρα. Ισχύουσα θεωρείται πάντοτε η Πολιτική Cookies, όπως διαμορφώθηκε
        από την πιο πρόσφατη τροποποίηση.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
